import { render, staticRenderFns } from "./TaoBaoPull.vue?vue&type=template&id=61158114&scoped=true"
import script from "./TaoBaoPull.vue?vue&type=script&lang=js"
export * from "./TaoBaoPull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61158114",
  null
  
)

export default component.exports